/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import moment from 'moment'

import 'moment/locale/pt';

import { enqueueSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { GetFetch } from '../../services/apiBase';
import { Box, Button, Typography } from '@mui/material';
import CustomizedTables from '../../components/Table';
import PaginationRounded from '../../components/NewPagination';
import FixedContainer from '../../components/Container';
import { DatePicker } from '@mui/x-date-pickers';
import EmptyMessage from '../../components/emptyMessage';
import LoadingComponent from '../../components/LoadingComponent';
import ErrorMessage from '../../components/errorMessage';

const Financeiro = ({ history }) => {

  const navigate = useNavigate()
  const [accrualDate, setAccrualDate] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [limit] = useState(25);
  const [cprAcumulatedAccrual, setCprAcumulatedAccrual] = useState(undefined)
  const [cprArray, setCprArray] = useState([])

  const COLUMNSTABLE = [
    {
      headerName: 'Número da CPR',
      type: 'deafult',
      value: {
        first: {
          value: 'cpr_number'
        },
      },
      noData: 'Não informado'
    },
    {
      headerName: 'Tipo',
      type: 'default',
      value: {
        first: {
          value: 'type'
        }
      }
    },
    {
      headerName: 'Status',
      type: 'default',
      value: {
        first: {
          value: 'status'
        }
      }
    },
    {
      headerName: 'Vencimento',
      type: 'date',
      value: {
        first: {
          value: 'date_end'
        }
      }
    },
    {
      headerName: 'Fazenda',
      type: 'default',
      value: {
        first: {
          value: 'farmhouse'
        }
      }
    },
    {
      headerName: 'Penhor',
      type: 'bool',
      value: {
        first: {
          value: 'has_pledge'
        }
      },
      trueMessage: 'Sim',
      falseMessage: 'Não',
      noData: 'Não informado'
    },
    {
      headerName: 'Valor investido',
      type: 'money',
      value: {
        first: {
          value: 'amount_cpr'
        }
      }
    },
    {
      headerName: 'Valor acumulado',
      type: 'money',
      value: {
        first: {
          value: 'accumulated_accrual'
        }
      }
    },
  ]

  const getCprAcumulated = async () => {
    setLoading(true)
    try {
      const { data } = await GetFetch('/financial/cprAccrual/getCprAccrualByDay', {
        params: {
          limit: limit,
          page: currentPage,
          date: new Date(accrualDate ? accrualDate : '')
        }
      })
      setCprArray(data.cprDailyAccrualsList.data)
      setCprAcumulatedAccrual(data.summary);
      setTotalPages(data.cprDailyAccrualsList.lastPage)
      setLoading(false)

      setError(false)
    } catch (error) {
      enqueueSnackbar('Erro ao buscar os rendimentos diários.', { variant: 'error' });
      setError(true)
    } finally {
      setLoading(false)
    }
  }

  const handleOpenDetails = (cpr) => {
    return navigate('/cprf/details', { state: { cpr: cpr } })
  }

  const TableComponent = () => {
    return (
      <Box>
        {cprArray && cprArray.length > 0
          ? 
          <>
            <CustomizedTables
              data={cprArray}
              columns={COLUMNSTABLE}
              options
              action={handleOpenDetails}
            />
            <Box sx={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
              height: '100%',
              justifyContent: 'center',
              paddingTop: 2
            }}>
              <PaginationRounded count={totalPages} page={currentPage} handleChange={setCurrentPage} />
            </Box>
          </>
          :
          <Box sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
            margin: 3
          }}>
            <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}>
              Não foram encontrados relatórios a serem listados
            </Typography>
          </Box>
        }
      </Box>
    )
  }

  useEffect(() => {
    if(accrualDate) {
      getCprAcumulated()
    }
  }, [currentPage])

  return (
    <FixedContainer>
      <Box sx={{
        width: '100%',
        height: '100%',
        backgroundColor: '#F9FBFD',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        boxShadow: 3,
        borderRadius: '10px',
        padding: 2,
      }}>
        <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 1 }}>
          Acumulado do dia
        </Typography>

        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>

          <DatePicker
            sx={{margin: '10px 0', width: '25%'}}
            label="Data inicial"
            value={accrualDate}
            format="DD/MM/YYYY"
            onChange={(newValue) => setAccrualDate(newValue)}
          />

          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
            <Button
              variant='contained'
              style={{ marginLeft: "1em" }}
              color="success"
              disabled={!accrualDate}
              onClick={() => getCprAcumulated()}
            >
              Selecionar
            </Button>
          </Box>

        </Box>

        {loading ? <LoadingComponent />
          : error ? <ErrorMessage message='Ocorreu um erro na busca pelo acumulado do dia selecionado' />
          : cprArray.length > 0 ?
            <>
              <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                marginY: 1,
              }}>
                <Box sx={{
                  display: 'flex',
                }}>
                  <Typography  sx={{ fontSize: 24 }}>Total de cprs: </Typography>
                  <Typography sx={{ fontSize: 24, marginLeft: 1 }}>{cprAcumulatedAccrual.totalcprs}</Typography>
                </Box>
                <Box sx={{
                  display: 'flex',
                }}>
                  <Typography sx={{ fontSize: 24 }}>Valor acumulado: </Typography>
                  <Typography sx={{ fontSize: 24, marginLeft: 1, color: 'green' }}>
                    {Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cprAcumulatedAccrual.totalDailyAccrual)}
                  </Typography>
                </Box>
              </Box>

              <TableComponent />

            </>
            : <EmptyMessage message='Não foram encontrados registros para o dia selecionado'/>
        }
      </Box>
    </FixedContainer>
  );
}

export default Financeiro;
